import type { NetworkTemplate } from "@models/networkTemplate.model";
import { CommandGetNetworkTemplates } from "./commands/cmdGetNetworkTemplates";
import { CommandGetNetworkTemplateDetail } from "./commands/cmdGetNetworkTemplateDetail";
import { CommandImportNetworkTemplate, type ImportNetworkTemplatePayload } from "./commands/cmdImportNetworkTemplate";
import { CommandUpdateNetworkTemplate, type UpdateNetworkTemplatePayload } from "./commands/cmdUpdateNetworkTemplate";
import { CommandDeleteNetworkTemplate } from "./commands/cmdDeleteNetworkTemplate";

// Thin orchestrator over the network template endpoints. The list is hard-coded
// to organization 4 inside the command — this feature runs concurrently with the
// legacy Network Presets until that is sunset.
export class NetworkTemplateService {
  async list(network?: string): Promise<NetworkTemplate[]> {
    return await new CommandGetNetworkTemplates().run(network);
  }

  async getDetail(templateId: number): Promise<NetworkTemplate> {
    return await new CommandGetNetworkTemplateDetail().run(templateId);
  }

  async import(payload: ImportNetworkTemplatePayload): Promise<NetworkTemplate> {
    return await new CommandImportNetworkTemplate().run(payload);
  }

  async update(templateId: number, payload: UpdateNetworkTemplatePayload): Promise<NetworkTemplate> {
    return await new CommandUpdateNetworkTemplate().run(templateId, payload);
  }

  async delete(templateId: number): Promise<void> {
    return await new CommandDeleteNetworkTemplate().run(templateId);
  }
}
